import axios from "axios";
import { API_BASE_URL, buildHeaders } from "utils/services";

export const resetClocks = async (user) => {

    try {
        const { data } = await axios.post(`${API_BASE_URL}/admin/clock/reset`, {},
            buildHeaders(user)
        )
        return data
    } catch (err) {
        throw err
    }
}